import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdCheckCircle, MdVisibility, MdHandshake, MdKeyboardArrowDown, MdKeyboardArrowUp, MdEmail, MdPhone } from 'react-icons/md';
import styles from "./Home.module.css";
import office from "./img/office.png";
import service from "./img/service.png";

function Home() {

    const [servicoAberto, setServicoAberto] = useState(null);

    const toggleServico = (index) => {
        if (servicoAberto === index) {
        setServicoAberto(null);
        } else {
        setServicoAberto(index);
        }
    };

    const listaServicos = [
        { id: 1, titulo: "1. Gestão Contábil", texto: "Auxiliamos sua empresa na organização e controle contábil, garantindo conformidade com as normas vigentes.", link: "/servico/gestao-contabil" },
        { id: 2, titulo: "2. Gestão de Empresas", texto: "Organizamos sua empresa desde sua base para crescimento sustentável.", link: "/servico/gestao-de-empresas" },
        { id: 3, titulo: "3. Gestão Trabalhista & RH", texto: "Controle total das necessidades trabalhistas, garantindo o cumprimento das obrigações fiscais.", link: "/servico/gestao-trabalhista-rh" },
        { id: 4, titulo: "4. Planejamento Tributário", texto: "Atuação focada em reduzir carga tributária com segurança jurídica.", link: "/servico/planejamento-tributario" },
        { id: 5, titulo: "5. Imposto de Renda", texto: "Elaboração e acompanhamento para garantir conformidade e evitar inconsistências.", link: "/servico/imposto-de-renda" },
        { id: 6, titulo: "6. Serviços Complementares", texto: "Alvarás, licenças, regulamentações, certificados digitais, previdência social, saúde ocupacional e exames médicos.", link: "/servico/servicos-complementares" },
    ];

    return (
        <div className={styles.homeContainer}>
        
            <section className={styles.bannerHero}>
                <div className={`${styles.conteudoSecao} ${styles.conteudoHero}`}>
                    <h1>Transforme sua gestão financeira e contábil com eficiência e segurança, conte conosco.</h1>
                    <p>Com nossos serviços conseguimos otimizar processos, reduzir custos e garantir a saúde financeira de seu negócio. Estamos prontos para ajudar em sua jornada rumo ao sucesso.</p>
                    <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em contato</Link>
                </div>
            </section>

            <section className={`${styles.sobreResumo} ${styles.bgClaro}`}>
                <div className={styles.conteudoSecao}>
                
                    <div className={styles.historiaContainer}>
                        <div className={styles.historiaTextos}>
                            <h2 className={styles.textoAzul}>Nossa História</h2>
                            <h3 className={styles.subtituloAzul}>A CPP Contabilidade</h3>
                            <p>A CPP Contabilidade surgiu com o objetivo de oferecer uma atuação diferente do modelotradicional da contabilidade.</p>
                            <p>Desde o início, a proposta foi clara: ir além da simples entrega de obrigações fiscais e oferecer organização, segurança e acompanhamento real para empresas que precisam de controle e previsibilidade.</p>
                            <p>Com experiência prática e atuação direta no dia a dia dos clientes, estruturamos processos que garantem mais clareza nas informações, evitam riscos e permitem uma gestão mais eficiente.</p>
                            <p>Ao longo da nossa trajetória, passamos a atender empresas que valorizam responsabilidade, organização e decisões bem fundamentadas, oferecendo um suporte próximo e uma atuação que contribui diretamente para o crescimento sustentável do negócio. Mais do que contabilidade, entregamos tranquilidade, controle e confiança.</p>
                            <Link to="/sobre" className={`${styles.btnLink} ${styles.btnCyan}`}>Conheça nossa empresa</Link>
                        </div>
                        <div className={styles.historiaImagem}>
                            <img src={office} alt="Escritório CPP Contabilidade" className={styles.imgEscritorio} />
                        </div>
                    </div>

                    <div className={styles.mvvContainer}>                        
                        <div className={`${styles.mvvCard} ${styles.cardMissao}`}>
                            <MdCheckCircle className={styles.cardIcon} /> {/* Novo ícone */}
                            <h4>Missão</h4>
                            <p>Prestar serviços contábeis com excelência e agregar valor aos clientes, pautados na ética, legalidade, humanidade, responsabilidade, qualidade e transparência.</p>
                        </div>
                        <div className={`${styles.mvvCard} ${styles.cardVisao}`}>
                            <MdVisibility className={styles.cardIcon} /> {/* Novo ícone */}
                            <h4>Visão</h4>
                            <p>Ser um escritório reconhecido pela qualidade, agilidade e precisão dos serviços prestados.</p>
                        </div>
                        <div className={`${styles.mvvCard} ${styles.cardValores}`}>
                            <MdHandshake className={styles.cardIcon} /> {/* Novo ícone */}
                            <h4>Valores</h4>
                            <p>Integridade, objetividade, confidencialidade, competência profissional e comportamental.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`${styles.servicosResumo} ${styles.bgBranco}`}> 
                <div className={styles.conteudoSecao}>
                
                    <div className={styles.introServicos}>
                        <h2 className={styles.textoAzul}>Descubra as soluções que oferecemos</h2>
                        <p>Veja alguns dos motivos pelos quais centenas de empresas nos escolhem para soluções contábeis de alta precisão, confiança e excelência, sempre focadas no sucesso do seu negócio.</p>
                    </div>

                    <div className={styles.servicosContainer}>
                        <div className={styles.servicosImagem}>
                            <img src={service} alt="Serviços CPP Contabilidade" className={styles.imgServicos} />
                        </div>

                        <div className={styles.servicosTextos}>
                            <h3 className={styles.subtituloAzul}>Nossos Serviços</h3>
                            <p className={styles.descricaoServicos}>Entenda um pouco do que fazemos:</p>

                            <div className={styles.accordionContainer}>
                                {listaServicos.map((servico, index) => (
                                    <div key={servico.id} className={styles.accordionItem}>
                                        <button
                                        className={styles.accordionHeader} 
                                        onClick={() => toggleServico(index)}
                                        >
                                            <span>{servico.titulo}</span>
                                            {servicoAberto === index ? <MdKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}
                                        </button>
                                        
                                        <div className={`${styles.accordionContent} ${servicoAberto === index ? styles.aberto : ''}`}>
                                            <p>{servico.texto}
                                                <Link to={servico.link} className={styles.link}> Saiba mais...</Link>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.blogResumo}>
                <div className={styles.conteudoSecao}>
                    <h2>Últimas do Blog</h2>
                    <p>Fique por dentro das novidades do mercado contábil, dicas de gestão e artigos exclusivos escritos por nossos especialistas.</p>
                    <Link to="/blog" className={styles.btnLink}>Acessar o Blog</Link>
                </div>
            </section>

           <section className={`${styles.contatoResumo} ${styles.bgAzul}`}>
                <div className={styles.conteudoSecao}>
                    
                    <h2 className={styles.textoBranco}>Entre em Contato!</h2>
                    <p className={styles.textoBranco}>
                        Precisa de ajuda com a contabilidade da sua empresa? Entre em contato conosco e descubra como podemos facilitar o seu dia a dia.
                    </p>

                    <div className={styles.contatoInfo}>
                        <div className={styles.infoItem}>
                            <MdPhone className={styles.infoIcon} />
                            <span>
                                <a href="tel:+551123650500" className={styles.phoneLink}>Tel: (11) 2365 - 0500</a>
                            </span> 
                        </div>
                        <div className={styles.infoItem}>
                            <MdEmail className={styles.infoIcon} />
                            <span>
                                <a href="mailto:Para faleconosco@cppcontabilidade.com.br" className={styles.emailLink}>E-mail: faleconosco@cppcontabilidade.com.br</a>
                            </span>
                        </div>
                    </div>

                    <div className={styles.contatoBotoes}>
                        <Link to="/contato" className={`${styles.btnWhite}`}>
                            Fale Conosco
                        </Link>
                        <a href="https://wa.link/yztfoa" target="_blank" rel="noopener noreferrer" className={`${styles.btnWhite}`} aria-label="Falar pelo WhatsApp">WhatsApp</a>
                    </div>
                </div>
            </section>
            {/* 6. SEÇÃO DE CLIENTES (Placeholder) */}
            {/* <section className={`${styles.clientesPlaceholder} ${styles.bgBranco}`}>
                <div className={styles.conteudoSecao}>
                <h2>Nossos Clientes</h2>
                <p>[ Espaço reservado para a logo dos clientes futuramente ]</p>
                </div>
            </section> */}

            {/* 7. SEÇÃO DE AVALIAÇÕES (Placeholder) */}
            {/* <section className={`${styles.avaliacoesPlaceholder} ${styles.bgClaro}`}>
                <div className={styles.conteudoSecao}>
                <h2>O que dizem sobre nós</h2>
                <p>[ Espaço reservado para o carrossel de depoimentos futuramente ]</p>
                </div>
            </section> */}

        </div>  
    );
}

export default Home;